export class TargetVolumeUpdateRequest {
    sampleBarcode : string;
    targetVolume : number;
    concentrationMeasurementRequired: boolean;
    volumeChanged : boolean;
    labId : string;
}